import { render, staticRenderFns } from "./loot_solver_distribution.vue?vue&type=template&id=518ceb8f"
import script from "./loot_solver_distribution.vue?vue&type=script&lang=ts"
export * from "./loot_solver_distribution.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports